import { useState } from "react"
import UserAddressSelect from "./addresses.select"
import AddressForm from "./address.form"
import { UserAddress, useUserAddresses } from "@/api/users"

interface AddressSelectOrCreateProps {
  defaultValue?: string;
  value?: string;
  onChange: (value: string) => void;
}

export default function AddressSelectOrCreate({
  defaultValue,
  value,
  onChange,
}: AddressSelectOrCreateProps) {
  const [addNew, setAddNew] = useState(false)
  const { create } = useUserAddresses()

  const onCreate = async (data: UserAddress) => {
    const userAddress = await create(data)
    setAddNew(false)
    return userAddress.id
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelect = (addressId: string, onChange: (...event: any[]) => void) => {
    if (addressId === "new") {
      setAddNew(true)
    } else {
      setAddNew(false)
      onChange(addressId)
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <UserAddressSelect
        defaultValue={defaultValue}
        value={value}
        onSelect={(addressId) => onSelect(addressId, onChange)}
        onAddNew={() => setAddNew(true)}
      />
      {addNew && (
        <AddressForm
          defaultValues={{
            streetLine1: "",
            streetLine2: "",
            city: "",
            countryId: "",
            stateId: "",
            postalCode: "",
          }}
          onSubmit={async (data) => onChange(await onCreate(data))}
        />
      )}
    </div>
  )
}
